module.exports = __webpack_public_path__ + "static/media/Step 10a-Game_Master.53c213e5.png";